export default {
  en: {
    buttons: {
      today: 'Today',
      month: 'Month',
      week: 'Week',
      day: 'Day',
      list: 'List',
    },
    my_reservations: {
      title: 'Your reservations',
      desc: "Ready to make your first reservation? It's easy! Select your desired period on the calendar or click the 'Book now' button above.",
    },
  },
};
